import { Service } from "../../config/service";

class StoreService extends Service {

  constructor() {
    super("stores")
  }

}

export default StoreService
